export default __webpack_public_path__ + "media/images/features/toyono/car-63ed8c31c748f676a9dbbf207d88e28a.png";